export default __webpack_public_path__ + "static/media/icon-star.72119afa.svg";